module.exports = __webpack_public_path__ + "static/media/desktop-active.7b03671d.svg";